import { section } from "@/neon";

import { animateListCollections } from "@/lib/animation";

section("list-collections", {
  onLoad() {
    this.animateListCollections = animateListCollections(this.container);
  },
  onUnload() {
    this.animateListCollections?.destroy();
  },
});
